module.exports = __webpack_public_path__ + "static/media/Benedicto Baragomwa.5eb6d078.jpg";